import { ShowHeader } from "@/common/components/ShowHeader";
import CardCurrentLimitEssentialInformation from "@/features/cardCurrentLimits/components/CardCurrentLimitEssentialInformation";
import CardCurrentLimitValues from "@/features/cardCurrentLimits/components/CardCurrentLimitValues";
import { useCardCurrentLimitsForm } from "@/features/cardCurrentLimits/hooks/useCardCurrentLimitsForm";

const CardCurrentLimitsShowMobile = () => {
  const {
    cardIdentifier,
    setCardIdentifier,
    products,
    product,
    setProduct,
    setSearchProduct,
    cardDetails,
    cardDetailsIsError,
    cardDetailsIsPending,
    cardCurrentLimits,
    cardCurrentLimitsIsPending,
  } = useCardCurrentLimitsForm();

  return (
    <div className="flex flex-col items-stretch w-screen h-dvh absolute top-0 left-0">
      <ShowHeader
        backTo="/home"
        title="Consulta"
        className="p-4 mb-0"
        titleClassName="text-base font-normal"
        goBackIconSize={24}
      />

      <div className="h-full overflow-auto flex flex-col gap-4 py-4">
        <CardCurrentLimitEssentialInformation
          cardIdentifier={cardIdentifier}
          setCardIdentifier={setCardIdentifier}
          products={products}
          setProduct={setProduct}
          setSearchProduct={setSearchProduct}
          cardDetails={cardDetails}
          cardDetailsIsError={cardDetailsIsError}
          cardDetailsIsPending={cardDetailsIsPending}
        />

        <CardCurrentLimitValues
          product={product}
          cardCurrentLimits={cardCurrentLimits}
          cardCurrentLimitsIsPending={cardCurrentLimitsIsPending}
          cardDetails={cardDetails}
        />
      </div>
    </div>
  );
}

export default CardCurrentLimitsShowMobile;
